angular.module('gym.website', ['model']).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.website', {
    abstract: true,
    template: require('templates/gyms/website/website.html.slim'),
    controller: 'WebsiteCtrl',
    resolve: {
      website: ["$stateParams", "$http", function($stateParams, $http) {
        return $http.get(`gyms/${$stateParams.gymId}/website`).then(function(response) {
          return response.data;
        });
      }]
    }
  }).state('gym.website.business', {
    url: '/website',
    template: require('templates/gyms/website/business.html.slim')
  }).state('gym.website.design', {
    url: '/website/website_design',
    template: require('templates/gyms/website/design.html.slim')
  }).state('gym.website.homepage', {
    url: '/website/home_page_copy',
    template: require('templates/gyms/website/homepage.html.slim')
  }).state('gym.website.contactUs', {
    url: '/website/contact_us_copy',
    template: require('templates/gyms/website/contact_us.html.slim')
  }).state('gym.website.requestMobileAppAccess', {
    url: '/website/request_mobile_app_access_copy',
    template: require('templates/gyms/website/request_mobile_app_access.html.slim')
  }).state('gym.website.gallery', {
    url: '/website/gallery_copy',
    template: require('templates/gyms/website/gallery.html.slim')
  }).state('gym.website.tac', {
    url: '/website/terms_and_conditions_copy',
    template: require('templates/gyms/website/tac.html.slim')
  }).state('gym.website.promotions', {
    url: '/website/promotions',
    template: require('templates/gyms/website/promotions.html.slim')
  }).state('gym.website.widgets', {
    url: '/website/integrations',
    template: require('templates/gyms/website/widgets_list.slim')
  });
// coffeelint: disable
}]).factory('Website', [
  'Model',
  function(Model) {
    var Website;
    return Website = (function() {
      class Website extends Model {
        constructor() {
          super(...arguments);
        }

      };

      Website.param = 'website';

      return Website;

    }).call(this);
  }
]);

// coffeelint: enable
